import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Components/Home";

import Lottie from "react-lottie";
import * as success from "../src/95029-success.json";
// import * as plane from "../src/97171-loading-plane.json";
import * as loadingText from "../src/4693-loading.json";

const defaultOptions1 = {
  loop: true,
  autoplay: true,
  animationData: loadingText.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: success.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function App() {
  const [loading, setLoading] = useState(false);
  const [completed, setcompleted] = useState(undefined);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
      setTimeout(() => {
        setcompleted(true);
      }, 1000);
    }, 8000);
  }, []);

  return (
    <>
      {!completed ? (
        <>
          {!loading ? (
            <Lottie
              options={defaultOptions1}
              width={300}
              style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          ) : (
            <Lottie
              options={defaultOptions2}
              width={150}
              style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          )}
        </>
      ) : (
        <div className="App">
          <Toaster />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            {/* <Route path="project/:id" element={<Project />} /> */}
          </Routes>
        </div>
      )}
    </>
  );
}

export default App;
